import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cea496be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "common-wrap header-wrap" }
const _hoisted_4 = { key: 1 }

import { ref } from 'vue'
import headerTop from './components/header-top.vue'
import headerBottom from './components/header-bottom.vue'
import headerScroll from './components/header-scroll.vue'
import headerPerson from './components/header-personspace.vue'
import { useRoute } from 'vue-router'


export default {
  __name: 'header',
  setup(__props) {

const route = useRoute()



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(route).path.includes('/personSpace'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(headerTop),
            _createVNode(headerBottom)
          ]),
          _createVNode(headerScroll)
        ]))
      : _createCommentVNode("", true),
    (_unref(route).path.includes('/personSpace'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(headerPerson)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}